export default {"src":"/_next/static/media/timeline-arrow-left.9543addb.svg","height":10,"width":14};